query ProductionsChartData {
  kpiCompanies {
    nodes {
      title
      amount
      linkSearchValue
    }
  }
}
